export const DEFAULT_ICON_COLOR = '#CBD5E1'
